<template>

    <MenuSiModuleMain/>
    <MenuSiConfiguration/>
<!--    <HeadingAppointments/>-->

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Payment Cancelled</h3>

                    <span>
                        Your payment was cancelled. Please try again if want to make changes to your Simply Investing subscription.
                    </span>

                </div>
            </div>
        </div>
    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuSiModuleMain from "@/components/menu/simodule/MenuSiModuleMain.vue";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import MenuSiConfiguration from "@/components/menu/simodule/MenuSiConfiguration.vue";
import PaymentService from "@/service/PaymentService";

export default {
    components: {
        MenuSiConfiguration,
        SiFooter,
        MenuSiModuleMain
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    computed: {
        isFormValid() {
            // Check if all required fields are filled and email is valid
            return (
                this.selectedLocation != null
            );
        },
        amount() {
            // Set default amount for cases where no options are selected
            let baseAmount = 0;
            let currency = "USD"

            // Example pricing logic:
            if (this.selectedLocation === 'CA') {
                currency = "CAD";
            } else if (this.selectedLocation === 'UK') {
                currency = "£";
            } else if (this.selectedLocation === 'ZA') {
                currency = "R";
            } else {
                currency = "USD";
            }

            if (this.selectedLocation === 'ZA') {
                baseAmount = 900;
            } else {
                baseAmount = 75;
            }

            if (this.selectedCountry != null) {
                if (this.selectedCountry.length > 1) {
                    if (this.selectedLocation === 'ZA') {
                        baseAmount += ((this.selectedCountry.length - 1) * 150);
                    } else {
                        baseAmount += ((this.selectedCountry.length - 1) * 15);
                    }
                }
            }

            if (this.selectedPlan === 'A') {
                baseAmount *= 6; // Apply annual multiplier
            }

            return `${currency} ${baseAmount}`;
        },
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[ConfigurationUpgrade][mounted] Data = ", userData);
            console.log("[ConfigurationUpgrade][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[ConfigurationUpgrade][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[ConfigurationUpgrade][mounted] userConfigData.data = ", userConfigData.data);

            if ((this.profile.rights === 'C') || (this.profile.rights === 'A')) {
                this.courseRights = "Yes"
            } else {
                this.courseRights = "No"
            }
        } catch (e) {
            console.error("[ConfigurationUpgrade][mounted] Could not find user config for user = ", this.userStore.user.id);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        console.log("[ConfigurationUpgrade][mounted] this.userConfiguration = ", this.userConfiguration);

        this.selectedCountry = this.countries.filter(country => country.code === 'US');
    },
    data() {

        return {
            profile: {},
            submitted: false,
            userConfiguration: {},
            companyConfiguration: {},
            selectedStripePriceId: null,
            courseRights: "No",
            confirmations: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            plans: [
                {name: 'Monthly', code: 'M'},
                {name: 'Annual', code: 'A'}
            ],
            locations: [
                {name: 'USD', code: 'US'},
                {name: 'CAD', code: 'CA'}
            ],
            selectedPlan: "M",
            selectedLocation: null,
            selectedCountry: [],
            emailError: false,
            countries: [
                {name: 'United States (NYSE, NASDAQ)', code: 'US'},
                {name: 'Canada (TSX)', code: 'CA'}
                // {name: 'UK (LSE)', code: 'UK'},
                // {name: 'South Africa (JSE)', code: 'ZA'}
            ],
        }
    },
    methods: {
        processBuy() {
            console.log("[ConfigurationUpgrade][processBuy] this.selectedCountry = ", this.selectedCountry);
            console.log("[ConfigurationUpgrade][processBuy] this.selectedCountry.length = ", this.selectedCountry.length);

            if (this.selectedCountry.length === 2) {

                if (this.selectedLocation === "CA") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1Q4q9NI88ZJ7U6eN3Ut5QQOc";
                    } else {
                        this.selectedStripePriceId = "price_1Q4q6xI88ZJ7U6eNLWScBDMV";
                    }

                } else if (this.selectedLocation === "UK") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1QGtxoI88ZJ7U6eNwG4xPIvm";
                    } else {
                        this.selectedStripePriceId = "price_1QGtvxI88ZJ7U6eNMcHN3xpQ";
                    }

                } else if (this.selectedLocation === "ZA") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1QGuRaI88ZJ7U6eN3aOV8NCR";
                    } else {
                        this.selectedStripePriceId = "price_1QGuPjI88ZJ7U6eNjRwzG7Cr";
                    }

                } else {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1Q4pe6I88ZJ7U6eNFMDSGMeD";
                    } else {
                        this.selectedStripePriceId = "price_1Q4pbtI88ZJ7U6eNpL3Wa0MB";
                    }
                }

            } else if (this.selectedCountry.length === 3) {
                if (this.selectedLocation === "CA") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1Q4q9iI88ZJ7U6eNXpQIV85I";
                    } else {
                        this.selectedStripePriceId = "price_1Q4q7bI88ZJ7U6eNK7RN1DSU";
                    }

                } else if (this.selectedLocation === "UK") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1QGtyKI88ZJ7U6eNbB0ylLwV";
                    } else {
                        this.selectedStripePriceId = "price_1QGtwMI88ZJ7U6eNyQLPFDiw";
                    }

                } else if (this.selectedLocation === "ZA") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1QGuRwI88ZJ7U6eNIuxQIlyX";
                    } else {
                        this.selectedStripePriceId = "price_1QGuQOI88ZJ7U6eNJkUkQT6h";
                    }

                } else {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1Q4peWI88ZJ7U6eNkSEgTGsn";
                    } else {
                        this.selectedStripePriceId = "price_1Q4pcII88ZJ7U6eN8mFYT3CT";
                    }
                }

            } else if (this.selectedCountry.length === 4) {
                if (this.selectedLocation === "CA") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1Q4qAFI88ZJ7U6eNWAscRrya";
                    } else {
                        this.selectedStripePriceId = "price_1Q4q80I88ZJ7U6eNfXhs5uzO";
                    }

                } else if (this.selectedLocation === "UK") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1QGtyoI88ZJ7U6eNI51D0lr8";
                    } else {
                        this.selectedStripePriceId = "price_1QGtwkI88ZJ7U6eN55OWffd6";
                    }

                } else if (this.selectedLocation === "ZA") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1QGuSaI88ZJ7U6eNeAtlMAp3";
                    } else {
                        this.selectedStripePriceId = "price_1QGuQxI88ZJ7U6eNtNvPspcv";
                    }

                } else {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1Q4pf3I88ZJ7U6eNUw0zxIJd";
                    } else {
                        this.selectedStripePriceId = "price_1Q4pclI88ZJ7U6eNbizalLA9";
                    }
                }

            } else {
                if (this.selectedLocation === "CA") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1Q4q8yI88ZJ7U6eNrV1DUI9B";
                    } else {
                        this.selectedStripePriceId = "price_1Q4q6KI88ZJ7U6eNIqdun7R7";
                    }

                } else if (this.selectedLocation === "UK") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1QGtxMI88ZJ7U6eNCYI4OvaM";
                    } else {
                        this.selectedStripePriceId = "price_1QGtuaI88ZJ7U6eN0jcmA0tr";
                    }

                } else if (this.selectedLocation === "ZA") {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1Qwsf1I88ZJ7U6eNIqHffDI5";
                    } else {
                        this.selectedStripePriceId = "price_1QGuCfI88ZJ7U6eNCM70YEFM";
                    }

                } else {
                    if (this.selectedPlan === 'A') {
                        this.selectedStripePriceId = "price_1Q4pdfI88ZJ7U6eNxapNjRyy";
                    } else {
                        this.selectedStripePriceId = "price_1Q4pY7I88ZJ7U6eNdDaeJrzZ";
                    }
                }

            }

            this.submitted = true;

            if (this.isFormValid) {

                try {

                    const customDataObj = {
                        siLocation: String(this.selectedLocation || ''), // Ensure string, fallback to empty string
                        siPlan: String(this.selectedPlan || ''),
                        siEnableUs: String(this.selectedCountry.some(country => country.code === 'US')), // Converts boolean to string
                        siEnableCa: String(this.selectedCountry.some(country => country.code === 'CA')),
                        siEnableUk: String(this.selectedCountry.some(country => country.code === 'UK')),
                        siEnableZa: String(this.selectedCountry.some(country => country.code === 'ZA')),
                        sendWelcomeEmail: String('Y')
                    };

                    // Verify that all keys and values are strings
                    const customDataObjAsStrings = Object.fromEntries(
                        Object.entries(customDataObj).map(([key, value]) => [String(key), String(value)])
                    );

                    var clientDto = {
                        email: this.profile.email,
                        companyId: this.profile.companyId,
                        rights: 'A',
                        status: 'A',
                        category: 'A',
                        customData: customDataObjAsStrings
                    };

                    console.log('[ConfigurationUpgrade][processBuy] clientDto = ', clientDto);

                    // this.selectedStripePriceId = "price_1QwrjrI88ZJ7U6eNaNA3YczC";

                    PaymentService.createStripeCheckoutSessionExistingClient(this.selectedStripePriceId, this.profile.email)
                        .then(response => {
                            console.log("[Pricing][processBuyStripe] Response = ", response);
                            console.log("[Pricing][processBuyStripe] response.data = ", response.data);
                            console.log("[Pricing][processBuyStripe] response.data.url = ", response.data.url);

                            // if (response.ok && response.data.url) {
                            window.top.location.href = response.data.url; // Redirect to Stripe Checkout
                            // } else {
                            //     console.error("Error starting checkout:", response.error);
                            // }

                            // this.$toast.add({
                            //     severity: 'success',
                            //     summary: 'Successful',
                            //     detail: 'Successfully got Stripe info. Awaiting payment.',
                            //     life: 3000
                            // });

                        })
                        .catch(e => {
                            console.log("[Pricing][processBuy] Error = ", e);
                            // this.$toast.add({
                            //     severity: 'error',
                            //     summary: 'Error',
                            //     detail: 'Failed to create account. Please try again.',
                            //     life: 3000
                            // });

                            if (e.response && e.response.status === 401) {
                                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                                // this.$router.push('/siLogin'); // Redirect to the specified login route
                                this.$router.replace('/siLogin');
                            } else {
                                // Handle other errors (e.g., network issues)
                                this.userStore.clearUser();
                                // this.$router.push('login'); // This is your existing fallback redirect
                                this.$router.replace('/siLogin');
                            }
                            return;
                        });

                    // ClientService.upgradeSiClient(clientDto)
                    //     .then(data => {
                    //         console.log("[ConfigurationUpgrade][processBuy] Response data = ", data);
                    //
                    //         this.$toast.add({
                    //             severity: 'success',
                    //             summary: 'Successful',
                    //             detail: 'Successfully upgraded account. Awaiting payment.',
                    //             life: 3000
                    //         });
                    //
                    //     })
                    //     .catch(e => {
                    //         console.log("[ConfigurationUpgrade][processBuy] Error = ", e);
                    //         // this.$toast.add({
                    //         //     severity: 'error',
                    //         //     summary: 'Error',
                    //         //     detail: 'Failed to create account. Please try again.',
                    //         //     life: 3000
                    //         // });
                    //     });

                } catch (e) {
                    console.error('[ConfigurationUpgrade][processBuy] Error:', e);

                    // this.$toast.add({
                    //     severity: 'error',
                    //     summary: 'Error',
                    //     detail: 'Failed to create account. Please try again.',
                    //     life: 3000
                    // });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            // setTimeout(() => {
            //     if (this.selectedCountry.length === 2) {
            //
            //         if (this.selectedLocation === "CA") {
            //             if (this.selectedPlan === 'A') {
            //
            //                 // setTimeout(() => {
            //                 //     if (this.selectedLocation === "CA" && this.selectedPlan === 'A') {
            //                 //         // window.top.location.href = "https://buy.stripe.com/5kA5lG7TDebe6LSdR3";
            //                 //         window.open("https://buy.stripe.com/5kA5lG7TDebe6LSdR3", '_blank');
            //                 //     }
            //                 // }, 500); // Small delay to ensure UI updates
            //
            //                 // window.top.location.href = "https://buy.stripe.com/5kA5lG7TDebe6LSdR3";
            //                 window.open("https://buy.stripe.com/5kA5lG7TDebe6LSdR3", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/cN23dya1L7MQdag8wF";
            //                 window.open("https://buy.stripe.com/cN23dya1L7MQdag8wF", '_blank');
            //             }
            //
            //         } else if (this.selectedLocation === "UK") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/aEU6pK2zj7MQ1ry5kN";
            //                 window.open("https://buy.stripe.com/aEU6pK2zj7MQ1ry5kN", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/4gwdScddXgjm8U06oN";
            //                 window.open("https://buy.stripe.com/4gwdScddXgjm8U06oN", '_blank');
            //             }
            //
            //         } else if (this.selectedLocation === "ZA") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/cN25lGgq91os3zG6oY";
            //                 window.open("https://buy.stripe.com/cN25lGgq91os3zG6oY", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/00gg0kei19UYfio6oV";
            //                 window.open("https://buy.stripe.com/00gg0kei19UYfio6oV", '_blank');
            //             }
            //
            //         } else {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/fZe5lG4Hr9UYfio4gm";
            //                 window.open("https://buy.stripe.com/fZe5lG4Hr9UYfio4gm", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/8wMbK48XH6IM0nudQS";
            //                 window.open("https://buy.stripe.com/8wMbK48XH6IM0nudQS", '_blank');
            //             }
            //         }
            //
            //     } else if (this.selectedCountry.length === 3) {
            //         if (this.selectedLocation === "CA") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/6oE7tOfm58QU6LS14i";
            //                 window.open("https://buy.stripe.com/6oE7tOfm58QU6LS14i", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/bIY8xSddXc365HO4gq";
            //                 window.open("https://buy.stripe.com/bIY8xSddXc365HO4gq", '_blank');
            //             }
            //
            //         } else if (this.selectedLocation === "UK") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/8wM8xS3Dn5EI7PW9B4";
            //                 window.open("https://buy.stripe.com/8wM8xS3Dn5EI7PW9B4", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/6oEg0k1vfaZ2c6c14u";
            //                 window.open("https://buy.stripe.com/6oEg0k1vfaZ2c6c14u", '_blank');
            //             }
            //
            //         } else if (this.selectedLocation === "ZA") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/4gw3dy1vfgjmfiocNn";
            //                 window.open("https://buy.stripe.com/4gw3dy1vfgjmfiocNn", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/cN29BW1vfgjm0nudRo";
            //                 window.open("https://buy.stripe.com/cN29BW1vfgjm0nudRo", '_blank');
            //             }
            //
            //         } else {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/5kA4hC8XH6IM8U0007";
            //                 window.open("https://buy.stripe.com/5kA4hC8XH6IM8U0007", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/dR63dygq93wA2vC003";
            //                 window.open("https://buy.stripe.com/dR63dygq93wA2vC003", '_blank');
            //             }
            //         }
            //
            //     } else if (this.selectedCountry.length === 4) {
            //         if (this.selectedLocation === "CA") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/3cs6pK4Hr0kofio8wL";
            //                 window.open("https://buy.stripe.com/3cs6pK4Hr0kofio8wL", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/fZe15q7TD5EIeek14f";
            //                 window.open("https://buy.stripe.com/fZe15q7TD5EIeek14f", '_blank');
            //             }
            //
            //         } else if (this.selectedLocation === "UK") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/4gw15qa1Lffi3zGbJd";
            //                 window.open("https://buy.stripe.com/4gw15qa1Lffi3zGbJd", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/eVa8xS8XH2sw9Y4fZp";
            //                 window.open("https://buy.stripe.com/eVa8xS8XH2sw9Y4fZp", '_blank');
            //             }
            //
            //         } else if (this.selectedLocation === "ZA") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/8wMbK4gq92sw0nubJk";
            //                 window.open("https://buy.stripe.com/8wMbK4gq92sw0nubJk", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/7sI6pKfm5ffigms8x5";
            //                 window.open("https://buy.stripe.com/7sI6pKfm5ffigms8x5", '_blank');
            //             }
            //
            //         } else {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/fZe6pK4Hrgjm0nuaEM";
            //                 window.open("https://buy.stripe.com/fZe6pK4Hrgjm0nuaEM", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/5kA9BW8XHd7a6LSbIM";
            //                 window.open("https://buy.stripe.com/5kA9BW8XHd7a6LSbIM", '_blank');
            //             }
            //         }
            //
            //     } else {
            //         if (this.selectedLocation === "CA") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/28og0k6Pz0ko5HO00c";
            //                 window.open("https://buy.stripe.com/28og0k6Pz0ko5HO00c", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/cN24hC4Hr3wA4DK4gg";
            //                 window.open("https://buy.stripe.com/cN24hC4Hr3wA4DK4gg", '_blank');
            //             }
            //
            //         } else if (this.selectedLocation === "UK") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/eVag0k4Hr4AE4DK28A";
            //                 window.open("https://buy.stripe.com/eVag0k4Hr4AE4DK28A", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/bIY7tOddX0ko2vC3cA";
            //                 window.open("https://buy.stripe.com/bIY7tOddX0ko2vC3cA", '_blank');
            //             }
            //
            //         } else if (this.selectedLocation === "ZA") {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/4gwaG0a1L1osgms9AU";
            //                 window.open("https://buy.stripe.com/4gwaG0a1L1osgms9AU", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/aEU3dyei1ebe4DKdRm";
            //                 window.open("https://buy.stripe.com/aEU3dyei1ebe4DKdRm", '_blank');
            //             }
            //
            //         } else {
            //             if (this.selectedPlan === 'A') {
            //                 // window.top.location.href = "https://buy.stripe.com/bIYaG0ddX9UYc6c9AF";
            //                 window.open("https://buy.stripe.com/bIYaG0ddX9UYc6c9AF", '_blank');
            //             } else {
            //                 // window.top.location.href = "https://buy.stripe.com/dR68xSei1c36eek3cd";
            //                 window.open("https://buy.stripe.com/dR68xSei1c36eek3cd", '_blank');
            //             }
            //         }
            //
            //     }
            //
            //     window.location.reload();
            //
            // }, 500); // Small delay to ensure UI updates

            this.submitted = false;

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
